import { useState } from "react";
import { message } from "antd";
import { studioApi } from "../../api";

interface Props {
  videoId: number;
  onSuccess: () => void;
}

function DelayForm({ videoId, onSuccess }: Props) {
  const [delayMsg, setDelayMsg] = useState("");
  const [delayedBy, setDelayedBy] = useState("");
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("LOGGED_IN_USER") || "{}");

  const handleSubmit = async () => {
    if (!delayedBy.trim()) {
      return message.error("Please enter delayed by");
    }
    if (!delayMsg.trim()) {
      return message.error("Please enter a delay message");
    }

    try {
      setLoading(true);
      await studioApi.post(`videos/${videoId}/delay`, {
        userId: user.id,
        message: delayMsg,
      });

      message.success("Delay message sent");
      setDelayMsg("");
      onSuccess();
    } catch (error: any) {
      message.error(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Failed to submit delay message"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border border-slate-200 bg-white shadow-sm rounded-md">
      <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
        <h3 className="font-semibold text-slate-800">
          Please enter reason of delay
        </h3>
      </div>

      <div className="p-4">
        <label className="block text-sm font-medium text-slate-700 mb-2">
          Operator's Name
        </label>

        <input
          type="text"
          value={delayedBy}
          onChange={(e) => setDelayedBy(e.target.value)}
          placeholder="Enter name"
          className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <label className="block text-sm font-medium text-slate-700 mb-2">
          Reason of Delay
        </label>
        <textarea
          value={delayMsg}
          onChange={(e) => setDelayMsg(e.target.value)}
          rows={4}
          placeholder="Enter delay reason..."
          className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <div className="mt-4 flex justify-end">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-1.5 bg-blue-900 text-white rounded-md  disabled:opacity-50 cursor-pointer"
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DelayForm;
